// global shared items
require('./shared')

require('../site_scripts/mtc_vue_import')

require('./shared_functions')

// carz homepage specific JS
require('../site_scripts/mtc_latest_image_ctas')
require('../site_scripts/mtc_carz_mobile_menu')
require('../site_scripts/mtc_carz_footer_menu_trigger')

// carz homepage specific styles
require('../../css/carz_content.less')